import { blue } from '@mui/material/colors';

export const palette = {
  mode: 'dark', // Set the mode to dark to affect global styles
  primary: {
    main: '#247CDE',
    dark: '#0D4C92',
    light: '#0381DC',
    contrastText: '#FFFFFF',
    outlineBorder: '#30B1EE',
    hover: '#0D4C92',
    focus: 'rgba(144, 202, 249, 0.3)',
    selected: 'rgba(44, 100, 162, 1)',
  },
  secondary: {
    main: blue[100],
    dark: blue[100],
    light: blue[100],
    contrastText: '#2B5F99',
    outlineBorder: '#1EABFA80',
    hover: blue[100],
    focus: '#3F4F6E',
    focusVisible: 'rgba(38, 174, 250, 0.30)',
    selected: 'rgba(63, 79, 110, 0.16)',
  },
  action: {
    active: '#FFFFFF',
    activatedOpacity: 1,
    hover: '#0D4C92',
    hoverOpacity: 0.5,
    selected: '#33B8F7',
    selectedOpacity: 0.16,
    focus: '#cecece',
    focusOpacity: 0.2,
    disabled: 'rgba(255, 255, 255, 0.38)',
    disabledOpacity: 0.38,
    disabledBackground: '#2669B3',
    lightDisabled: '#C4D7E2',
  },
  info: {
    main: '#0D79DE',
  },
  error: {
    light: '#E57373',
    main: '#F44336',
    dark: '#BC3517',
  },
  success: {
    light: '#C5E0B4',
    main: '#4CAF50',
    dark: '#388E3C',
  },
  common: {
    white: '#ffffff',
    black: 'black',
    grayLight: '#CCCCCC',
    grayDark: '#98999C',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#D3D4CE',
  },
  background: {
    default: '#121212', // Dark background
    paper: '#1E1E1E', // Dark paper background
  },
};
